import {
    SET_CUSTOMER_SERVICE_SCOPE
} from "../../types";

const initialState = {
    /*
     * Filters for Customer Service Dashboard Datatables
     */
    scope: {},
};

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case SET_CUSTOMER_SERVICE_SCOPE:
            return {
                scope: { ...payload }
            };
        default:
            return state;
    }
}
